export default {
  OTHER: 'OTHER',
  SUGARS: 'SUGARS',
  OIL_CROPS: 'OIL_CROPS',
  CEREALS_AND_OTHER_STARCH_RICH_CROPS: 'CEREALS_AND_OTHER_STARCH_RICH_CROPS',
};
